import './styles.scss';
import Partner from './Partner'
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';

const TrastedPartners = ({ data, isLoading }) => {

    const container = useRef();

    useAnimation({
        items: ['.trasted-partners__title', '.trasted-partners-item'],
        container,
        dependencies: [isLoading],
    })
    const { logo, title } = data
    return (
        <section ref={container} className="trasted-partners">
            <div className='inner-container'>
                <div className="body2 trasted-partners__title">{title}</div>
                <div className='trasted-partners__container'>
                    {
                        logo?.map((icon, index) => <Partner key={index} icon={icon} />)
                    }
                </div>
            </div>
        </section>
    );
}

export default TrastedPartners;